<template>
  <v-menu open-on-hover>
    <template #activator="{ props }">
      <v-icon v-bind="props" class="mb-1 ml-1">
        mdi-information-outline
      </v-icon>
    </template>
    <v-card class="pa-3">
      <b>Words in Text Search</b>
      <br />
      This search function allows users to search for words and forms of words
      in texts.
      <ol>
        <li>Start by searching for a word or form in the search area.</li>
        <li>Select the word or form you are searching for.</li>
        <li>
          Then, check any other forms in relation to that word or form that you
          would like to search for.
        </li>
        <li>
          To specify the number of words in between words/forms you are
          searching for, select an option in 'words between'.
        </li>
      </ol>

      <b>Search Modes</b><br />

      Sequenced - Forces word forms to be in sequence (i.e., word/form #1,
      word/form #2, word/form #3)
      <br />
      Unsequenced - searches for word forms in any particular order
      <br />
      <br />
      <b>Note:</b> Words added vertically to the search (i.e., word form #1, #2,
      etc.) functionally have an <b>AND</b> relationship. Words added
      horizontally (i.e., multiple words in word form #1) functionally have an
      <b>OR</b> relationship.
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style></style>
